import { render, staticRenderFns } from "./LendingSideMenu.vue?vue&type=template&id=33e87002&scoped=true"
import script from "./LendingSideMenu.vue?vue&type=script&lang=js"
export * from "./LendingSideMenu.vue?vue&type=script&lang=js"
import style0 from "./LendingSideMenu.vue?vue&type=style&index=0&id=33e87002&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e87002",
  null
  
)

export default component.exports